import { ShieldCheck, FileText, Mail, Phone, MapPin } from "lucide-react";
import { motion } from "framer-motion";
import { ALLOCATION } from "@/lib/data";
import { Reveal } from "@/components/Reveal";

export default function Transparency() {
  return (
    <section id="transparency" className="relative bg-pine py-20 sm:py-24 lg:py-28 text-sand grain overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <p className="dark-eyebrow">Transparency</p>
            <h2 className="mt-3 font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight">
              A 501(c)(3) you can check up on.
            </h2>
            <p className="mt-4 text-sand/75 leading-relaxed">
              Wag n Tails Mountain Retreat Rescue is a registered 501(c)(3) nonprofit.
              Every gift is tax-deductible to the fullest extent allowed by law, and your receipt lands in your inbox the moment you give.
            </p>
            <div className="mt-8 space-y-4">
              <div className="flex items-center gap-3 rounded-2xl bg-pine-deep/60 p-4" data-testid="ein-chip">
                <FileText className="h-5 w-5 text-gold-soft shrink-0" />
                <p className="font-mono text-sm">EIN: 87-0992741</p>
              </div>
              <div className="flex items-center gap-3 rounded-2xl bg-pine-deep/60 p-4">
                <ShieldCheck className="h-5 w-5 text-gold-soft shrink-0" />
                <p className="text-sm text-sand/85">Financials reviewed annually — reports available on request.</p>
              </div>
              <div className="flex items-center gap-3 rounded-2xl bg-pine-deep/60 p-4">
                <Mail className="h-5 w-5 text-gold-soft shrink-0" />
                <p className="font-mono text-sm text-sand/85">donate4pawz@gmail.com · (301) 723-0010</p>
              </div>
              <div className="flex items-center gap-3 rounded-2xl bg-pine-deep/60 p-4">
                <MapPin className="h-5 w-5 text-gold-soft shrink-0" />
                <p className="font-mono text-sm text-sand/85">Maryland mountains, USA</p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.15} className="lg:col-span-7">
            <div className="rounded-3xl bg-pine-deep/60 p-6 sm:p-10">
              <h3 className="font-serif text-xl sm:text-2xl">Where your dollar goes</h3>
              <div className="mt-8 flex h-10 w-full overflow-hidden rounded-full" data-testid="allocation-bar">
                {ALLOCATION.map((a, i) => (
                  <motion.div key={a.label} className={`${a.color} h-full first:rounded-l-full last:rounded-r-full`}
                    initial={{ width: 0 }} whileInView={{ width: `${a.pct}%` }}
                    viewport={{ once: true }} transition={{ duration: 1.2, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }} />
                ))}
              </div>
              <div className="mt-6 space-y-3">
                {ALLOCATION.map((a) => (
                  <div key={a.label} className="flex items-center justify-between border-b border-sand/10 pb-3 last:border-0">
                    <span className="flex items-center gap-3 text-sm text-sand/85">
                      <span className={`h-3 w-3 rounded-full ${a.color}`} /> {a.label}
                    </span>
                    <span className="font-mono font-bold text-gold-soft" data-testid={`allocation-${a.pct}`}>{a.pct}%</span>
                  </div>
                ))}
              </div>
              <p className="mt-6 font-mono text-[10px] uppercase tracking-widest text-sand/40">
                100% of every donation goes directly to the animals
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
